export default __webpack_public_path__ + "static/media/phone.0452bb91.svg";